export function resizeObserverBorderBoxSize(entry: ResizeObserverEntry): { width: number; height: number } {
  const borderBoxSize = entry.borderBoxSize;
  const box = Array.isArray(borderBoxSize) ? borderBoxSize[0] : borderBoxSize;
  if (box) {
    return { width: box.inlineSize, height: box.blockSize };
  }
  return { width: entry.contentRect.width, height: entry.contentRect.height };
}
